import axios from "axios";
import { login } from "./auth";
let token = localStorage.getItem("token");

const API = axios.create({
  baseURL: process.env.REACT_APP_URL,
});

API.interceptors.request.use(async (config: any) => {
  if (token) {
    let tokenParsed = JSON.parse(token);
    config.headers.Authorization = `Bearer ${tokenParsed}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      const rememberMe = localStorage.getItem("rememberMe");

      if (rememberMe === "true") {
        console.log("rememberMe === true");
        originalRequest._retry = true;
        try {
          console.log("try");
          const email = localStorage.getItem("email");
          const password = localStorage.getItem("password");
          const role = localStorage.getItem("role");
          if (!email || !password || !role) {
            localStorage.clear();
            window.location.href = "/";
            return Promise.reject(error);
          }

          const { data } = await login({ email, password, role });
          const newToken = data.accessToken;
          localStorage.setItem("token", JSON.stringify(newToken));
          originalRequest.headers.Authorization = `Bearer ${newToken}`;
          return API(originalRequest);
        } catch (refreshError) {
          localStorage.clear();
          window.location.href = "/";
          return Promise.reject(refreshError);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default API;
